import styled from 'styled-components'

export const WorkInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
